import { IThirdPartyPopupBodyProps } from '../types/IThirdPartyPopup';

/**
 * Interface for feedback link
 */
export interface IFeedbackType {
  href: string;
  label: string;
  target?: string;
}

/**
 * Interface for Button
 */
export interface IButtonType {
  label?: string;
  variant?: string;
  onClick?: () => void;
  className?: string;
  isIconVisible?: boolean;
  iconSrc?: string;
  dataTestId?: string;
}

/**
 * Interface for Header Top bar
 */
export interface IHeaderTopbarProps {
  brandAlt?: string;
  brandSrc?: string;
  brandWidth?: string;
  brandHeight?: string;
  brandClassName?: string;
  brandURL?: string;
  welcomeMessage?: string;
  topBarHeading?: string;
  isBrandVisible?: boolean;
  isTopBarHeadingVisible?: boolean;
  isButtonVisible?: boolean;
  buttonArray?: Array<IButtonType>;
  dropdownButtonArray?: Array<any>;
  isHeaderMenusFocusable?: boolean;
}

/**
 * Interface for menu
 */
interface IMenuType {
  href?: string;
  label?: string;
  target?: string;
}

/**
 * Inteface for header navbar
 */
export interface IHeaderNavbarProps {
  menuArray?: Array<IMenuType>;
  isRefreshText?: boolean;
  refreshText?: string;
  refreshTextMobile?: string;
  isButtonVisible?: boolean;
  buttonArray?: Array<IButtonType>;
  feedbackArray?: Array<IFeedbackType>;
  isMenuVisible?: boolean;
  isHeaderMenusFocusable?: boolean;
  brandSrc?: string;
  brandImageAriaLabel?: string;
  thirdPartyPopupBodyProps?: IThirdPartyPopupBodyProps;
}

/**
 * Interface for Header
 */
export interface IHeaderProps {
  brandAlt?: string;
  brandSrc?: string;
  brandWidth?: string;
  brandHeight?: string;
  brandClassName?: string;
  brandURL?: string;
  welcomeMessage?: string;
  topBarHeading?: string;
  isBrandVisible?: boolean;
  isTopBarHeadingVisible?: boolean;
  menuArray?: Array<IMenuType>;
  isRefreshText?: boolean;
  refreshText?: string;
  refreshTextMobile?: string;
  isButtonVisible?: boolean;
  buttonArray?: Array<IButtonType>;
  dropdownButtonArray?: Array<any>;
  feedbackArray?: Array<IFeedbackType>;
  isMenuVisible?: boolean;
  isHeaderMenusFocusable?: boolean;
  brandImageAriaLabel: string;
  thirdPartyPopupBodyProps?: IThirdPartyPopupBodyProps;
}

/**
 * Enum for button variant
 */
export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Link = 'link-button',
  OutlinePrimary = 'outline-primary',
}
